import { NgModule } from '@angular/core';
import { DecimalNumberDirective } from './decimal-number.directive';

@NgModule({
    declarations: [
        DecimalNumberDirective
    ],
    exports: [
        DecimalNumberDirective
    ]
})
export class DecimalNumberDirectiveModule { }
